class HomepagePromoCarouselController extends window.MediaQueryController {
  connect() {
    if (
      this.activeBreakpoint === "small" ||
      this.activeBreakpoint === "medium"
    ) {
      this.initSwiper();
    }

    this.onWindowResize((activeBreakpoint) => {
      if (activeBreakpoint === "small" || activeBreakpoint === "medium") {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    });
  }

  initSwiper() {
    if (this.swiper) return;
    this.swiper = new Swiper(this.element, {
      slidesPerView: "auto",
      spaceBetween: 10,
      pagination: {
        el: ".homepage-promo-carousel-pagination",
        clickable: true,
        bulletClass:
          "swiper-pagination-bullet tw-border tw-border-blue-700 tw-bg-transparent tw-opacity-100",
        bulletActiveClass: "!tw-bg-blue-700",
      },
      autoplay: false,
      observer: true,
      observeParents: true,
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

Stimulus.register("homepage-promo-carousel", HomepagePromoCarouselController);
